import KitText from '@omni/kit/components/KitText';
import KitTouchable from '@omni/kit/components/KitTouchable';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { View } from 'react-native';

export default ({
  onPress,
  text,
}: {
  onPress: () => void;
  text: string;
}): ReactElement => {
  const buttonStyles = {
    backgroundColor: '#edeef0',
    height: 34,
    borderRadius: 17,
    justifyContent: 'center',
    paddingLeft: Spacing.s,
    paddingRight: Spacing.s,
  };

  return (
    <View style={{ marginRight: Spacing.s, marginTop: Spacing.m }}>
      <KitTouchable style={buttonStyles} onPress={onPress}>
        <KitText color={Colors.N800} semiBold>
          {text}
        </KitText>
      </KitTouchable>
    </View>
  );
};
